import html from "html-literal";
import anxiety from "../../assets/images/anxiety.jpg";
// import anxietyin from "../../assets/images/anxietyin.jpg";
import sprevent1 from "../../assets/images/sprevent1.jpg";
import sprevent2 from "../../assets/images/sprevent2.jpg";
import congratscheer from "../../assets/images/congratscheer.jpg";
import happybdaysis from "../../assets/images/happybdaysis.png";
import sympathy1 from "../../assets/images/sympathy1.jpg";
import Thankyou1 from "../../assets/images/Thankyou1.png";
import Romanceking from "../../assets/images/Romanceking.jpg";
import blueanniversary from "../../assets/images/blueanniversary.jpg";
import numberone from "../../assets/images/numberone.jpg";
import romancepuffs from "../../assets/images/romancepuffs.jpg";
import Hbdwife from "../../assets/images/Hbdwife.png";
import marketing1 from "../../assets/images/marketing1.jpg";
// import Hbdwifein from "../../assets/images/Hbdwifein.png";
// import Queen from "../../assets/images/Queen.jpg";
import Father from "../../assets/images/Father.png";
import dad from "../../assets/images/dad.png";
import uncle from "../../assets/images/uncle.png";
import HeroF from "../../assets/images/HeroF.png";
import grandpa from "../../assets/images/grandpa.png";
import coparent from "../../assets/images/coparent.jpg";
import gentledad from "../../assets/images/gentledad.png";

export default () => html`

<section>
  <div class="w3-container">
    <h1>Take a look at our cards!</h1><br>

    <section id="jumbotron">
      </div>

    <button id="myBtn"
      >"Coupon!" </button>
    <br><br>



  </section>
  <div id="fathersday">
    <h4> Use code "Fav Guy" starting May 15th to get 10% off</P>

    <div id="read"> <p>Please read the carts page to place an order<p></div><br>

    <div id="cards">

    <ul>
    <a href="https://drive.google.com/file/d/1DalBWcW_YZtP3uILp3dujs61kZqXZQvN/view?usp=sharing" target="_blank"><img src=${Father} alt="fathersday" width=300x300/><br> Father <br> Seasonal $5.00 <br> Celebrating father figures <br></a>
  </ul>

  <ul>
  <a href="https://drive.google.com/file/d/1Dr3AAxzdh32P1CWGK8mNHyPoci6BUxUI/view?usp=sharing"
        target="_blank">
    <img src=${dad} alt="fathersday" width=300x300><br> Dad <br> Seasonal $5.00 <br> Celebrating father figures<br></a>
  </ul>

   <ul>
    <a href="https://drive.google.com/file/d/1E38Hl5TenojweiukmeEjldnOYAReLcuu/view?usp=sharing" target="_blank"><img src=${uncle} alt="fathersday" width=300x300/><br> Uncle <br> Seasonal $5.00 <br> Celebrating father figures <br></a>
  </ul>

  <ul>
    <a href="https://drive.google.com/file/d/1EuhXAO4x6bbx7gqumbPRei87zDKoqST9/view?usp=sharing" target="_blank">
    <img src=${HeroF} alt="fathersday" width=300x300/><br> Hero <br> Seasonal $5.00 <br> Celebrating father figures <br></a>
  </ul>

  <ul>
    <a href="https://drive.google.com/file/d/1FQ4ybjE28E3aviE_7F7_76oSM2B73obK/view?usp=sharing" target="_blank">
    <img src=${grandpa} alt="fathersday" width=300x300/><br> Grandpa <br> Seasonal $5.00 <br> Celebrating father figures <br></a>
  </ul>

  <ul>
    <a href="https://drive.google.com/file/d/1EPdtqVJKMYocDFvrFKUOQmQUqmHb1RCE/view?usp=sharing" target="_blank">
    <img src=${coparent} alt="fathersday" width=300x300/><br> Coparent <br> Seasonal $5.00 <br> Celebrating father figures <br></a>

  </ul>

  <ul>
    <a href="https://drive.google.com/file/d/1DS2JUFPUiF7hgdoPQTV6tmFDdoG5zVpn/view?usp=sharing" target="_blank">
    <img src=${gentledad} alt="fathersday" width=300x300/><br> Gentle Dad <br> Seasonal $5.00 <br> Celebrating father figures <br></a>
  </ul>

          <p><h2>Mental Health</h2></p>

     <ul>If you or someone you know need immediate help,please call the National Suicide prevention
Line 800.273.TALK (8255) Or text BC2M to the Crisis Line at 741741
<br></ul>

<ul><a href="https://drive.google.com/file/d/1z1oArgAefe4hnce2uKPN1BvPGplVE4VP/view?usp=sharing" target="_blank">
  <img src=${anxiety} alt="anxiety" width=300x300/><br> Anxiety <br> Mental Health $3.00 <br> For life's mental and emotional challenges<br></a>
</ul>

<ul><a href="https://drive.google.com/file/d/1z3PJ-Wg_NFQhgWOxgdcT1w7T2VNIesJV/view?usp=sharing" target="_blank">
     <img src=${sprevent1} alt="sprevent1" width=300x300/><br> Prevention <br> Mental Health $3.00 <br> For life's mental and emotional challenges </a>
   </ul><br>

   <ul><a href="https://drive.google.com/file/d/1z2_OQavItChFBHImVJtW--s2wSiqYR_E/view?usp=sharing" target="_blank">
     <img src=${sprevent2} alt="sprevent2" width=300x300/><br> Prevention2 <br> Mental Health $3.00 <br> For life's mental and emotional challenges </a>
   </ul><br>

   <p><h2>General Greetings</h2></p>

      <ul><a href="https://drive.google.com/file/d/1V_cIcxDAUXN4CJBVIcUkuoV5J2TLLK_6/view?usp=sharing" target="_blank"><img src=${congratscheer} alt="congratscheer" width=300x300/><br> Congrats Cheer <br> Greeting $3.00 <br> For written expressions <br>  <br></a>
   </ul>

   <ul>
     <a href="https://drive.google.com/file/d/1VEFbHJ59t_9jyw15I2Xch8nJdAizDrSR/view?usp=sharing" target="_blank">
     <img src=${sympathy1} alt="sympathy1" width=300x300/><br>Sympathy<br>Greeting $3.00<br> For written expressions <br></a>
     </ul>

     <ul><a href="https://drive.google.com/file/d/1VVQ2ckW1tcYlomSl4wY6nPnvT3LOVad1/view?usp=sharing" target="_blank">
   <img src=${Thankyou1} alt="Thankyou" width=300x300/><br>Thank You<br>Greeting $3.00<br> For written expressions <br></a>
   </ul>

   <ul><a href="https://drive.google.com/file/d/1ywuh29H2jUoulhuiVAevunJk-nmKF7A9/view?usp=sharing" target="_blank">
   <img src=${happybdaysis} alt="happybdaysis" width=420x300/><br> Happy bday Sis<br>Greeting $3.00<br> For written expressions <br></a>
   </ul>


   <p><h2>Romance</h2></p>

<ul>
<a href="https://drive.google.com/file/d/1ystddfX_ai2adERNDmya8VSJCSOz_tLv/view?usp=sharing" target="_blank">
   <img src=${Romanceking} alt="Romance King" width=300x300/><br>Romance King<br>Romance $5.00<br> For those you share a bed with <br></a>
   </ul>

   <ul>
   <a href="https://drive.google.com/file/d/1UOyq7LcuxoFjCXhh5PMaYrZSHFbj5rC4/view?usp=sharing" target="_blank"><img src=${blueanniversary} alt="blue anniversary" width=300x300/><br>Blue Anniversary<br>Romance $5.00<br> For those you share a bed with <br></a>
</ul>

<ul><a href="https://drive.google.com/file/d/1z9u2N9xcEP2652nEAQxc1FMCUHC4r9B7/view?usp=sharing" target="_blank">
<img src=${numberone} alt="Number one" width=300x300/><br>Number One<br>Romance $5.00<br> For those you share a bed with <br></a>
   </ul>

   <ul><a href="https://drive.google.com/file/d/1zPNcMjIu-dZoHt24A_0MSk8oM7GUTDkB/view?usp=sharing" target="_blank">
        <img src=${Hbdwife} alt="Happy Bday Wife" width=300x300/><br>Happy Bday Wife<br>Romance $5.00<br> For those you share a bed with <br></a>
   </ul>

   <ul><a href="https://drive.google.com/file/d/1zM-PyoalD7AGZhuyQWpOt2Ysiy3nhspE/view?usp=sharing" target="_blank">
   <img src=${romancepuffs} alt="Romance Puffs" width=420x300/><br>Romance Puffs<br>Romance $5.00<br> For those you share a bed with</a>
   </ul>


   </div>
   </div>



  <p><h2>Custom</h2></p>

</section>
<div class="custom">
<img src=${marketing1} alt="Marketing" width=300x300/><br>Custom $10.00 <br> For making it personal <br></div>

<form
  action="https://formspree.io/f/xrgjzyzy"
  method="POST"
>
  <label>
    Your email:
    <input type="email" name="email">
  </label><br>
  <label>
    Your font:
    <input type="text" name="font">
  </label><br>
  <label>
    Your color:
    <input type="color" name="color">
  </label><br>
  <label>
    Your occasion:
    <input type="text" name="occasion">
  </label><br>
  <label>
    Your message:
    <textarea name="message"></textarea>
  </label><br>
  <!-- your other form fields go here -->
  <button type="submit">Send</button>
</form><br><br><br><br><br><br><br><br><br><br>



                            <h3>
                                <p><a href="https://www.instagram.com/kittypinkcards/?hl=en">Follow us on Instagram!</a></p>
                                <p><a href="https://www.linkedin.com/m/in/kelby-a-estes-nelson-83350826/">Follow us on Linkedin!</a></p>.
                            </h3>
</body>
© 2021 KittyPinkCards LLC`;
